import { BackendQueryKeys, useTypeSafeQuery } from '@oresundsbron/api';
import { LicensePlateInfo } from '~/components/Forms/RegisterAlpr/types';

export function useVehicleInformation(plateInfo: LicensePlateInfo) {
  const { country, licensePlate } = plateInfo || {};

  return useTypeSafeQuery(
    BackendQueryKeys.VehicleInfo(plateInfo),
    ({ VehicleInfo }) =>
      VehicleInfo.getBilvVehicleInfo(country as string, licensePlate as string),
    {
      enabled: !!plateInfo && !!country && !!licensePlate,
      retry: 0,
    }
  );
}
